import { engagementSteps, supportHighlights } from '@/mocks/services';

export default function ProcessSection() {
  return (
    <section id="process" className="py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary-600 font-semibold text-sm uppercase tracking-widest">How We Work</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-3 text-foreground-950">
            A straightforward path from problem to fix
          </h2>
          <p className="text-foreground-600 mt-4">
            No drawn-out sales cycle and no mystery invoices. Four clear steps, and you always know what
            happens next.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {engagementSteps.map((s) => (
            <div key={s.step} className="relative bg-background-50 border border-background-200 rounded-lg p-7">
              <span className="absolute top-6 right-6 text-3xl font-bold text-background-300">{s.step}</span>
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold mt-5 text-foreground-950">{s.title}</h3>
              <p className="text-foreground-600 text-sm mt-2 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-primary-900 rounded-lg grid grid-cols-2 lg:grid-cols-4 gap-6 p-10">
          {supportHighlights.map((h) => (
            <div key={h.label} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto rounded-md bg-primary-800 text-accent-500">
                <i className={`${h.icon} text-xl`}></i>
              </div>
              <div className="text-2xl font-bold text-background-50 mt-4">{h.value}</div>
              <div className="text-sm text-background-200/80 mt-1">{h.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}